const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSbti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.60676 1.41748C3.65797 1.41748 1.26672 3.80873 1.26672 6.75751C1.26672 9.7063 6.60676 18.758 6.60676 18.758C6.60676 18.758 11.9468 9.7063 11.9468 6.75751C11.945 3.80873 9.55378 1.41748 6.60676 1.41748Z",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 0.995614,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60687 9.60534C8.2765 9.60534 9.63 8.25184 9.63 6.58221C9.63 4.91258 8.2765 3.55908 6.60687 3.55908C4.93724 3.55908 3.58374 4.91258 3.58374 6.58221C3.58374 8.25184 4.93724 9.60534 6.60687 9.60534Z",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 0.995614,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9544 13.9438C19.0056 13.9438 16.6144 16.3351 16.6144 19.2839C16.6144 22.2327 21.9544 31.2844 21.9544 31.2844C21.9544 31.2844 27.2927 22.2327 27.2927 19.2839C27.2927 16.3351 24.9032 13.9438 21.9544 13.9438Z",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 0.995614,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9543 22.1298C23.6239 22.1298 24.9774 20.7763 24.9774 19.1066C24.9774 17.437 23.6239 16.0835 21.9543 16.0835C20.2847 16.0835 18.9312 17.437 18.9312 19.1066C18.9312 20.7763 20.2847 22.1298 21.9543 22.1298Z",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 0.995614,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9544 31.2822H9.0866C7.38742 31.2822 6.01038 29.9052 6.01038 28.206C6.01038 26.4466 7.43698 25.02 9.19634 25.02H11.2761C13.0354 25.02 14.462 23.5934 14.462 21.834C14.462 20.1349 13.085 18.7578 11.3858 18.7578H6.60686",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 0.995614,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSbti);
export default __webpack_public_path__ + "static/media/icon-sbti.34d772c8af3006481458718280bdc2de.svg";
export { ForwardRef as ReactComponent };